import i18n from "i18next"

const getTranslatedProxy = proxyCode => {
  return i18n.t(`proxy.country.${proxyCode}`)
}

const transformProxyCountries = proxyCountries => {
  return proxyCountries.map(country => ({
    countryCode: country.countryCode,
    countryName: getTranslatedProxy(country.countryCode),
  }))
}

export { getTranslatedProxy, transformProxyCountries }
